import React, { useState, useEffect } from 'react';
import { useData } from '../context/DataContext';
import { formatCurrency } from '../utils/formatters';
import '../styles/ScrollEarnings.css';

function ScrollEarnings() {
  const { billionaires } = useData();
  const [earnings, setEarnings] = useState(0);
  const [startTime] = useState(Date.now());

  useEffect(() => {
    const calculateEarnings = () => {
      if (!billionaires || billionaires.length === 0) return;
      
      // Get the top billionaire
      const topBillionaire = billionaires[0];
      const initialWorth = topBillionaire.worth;
      
      // Calculate time elapsed in seconds
      const timeElapsed = (Date.now() - startTime) / 1000;
      
      // Calculate earnings using compound interest
      const annualReturn = 0.07;
      const secondlyReturn = annualReturn / (365 * 24 * 60 * 60);
      const finalWorth = initialWorth * Math.pow(1 + secondlyReturn, timeElapsed);
      const totalEarnings = finalWorth - initialWorth;
      
      setEarnings(totalEarnings);
    };

    const timer = setInterval(calculateEarnings, 1000);
    return () => clearInterval(timer);
  }, [billionaires, startTime]);

  if (!billionaires || billionaires.length === 0) return null;

  return (
    <div className="scroll-earnings">
      <p>
        While you've been scrolling, {billionaires[0].name} has earned{' '}
        <span className="earnings-amount">{formatCurrency(earnings)}</span>
      </p>
    </div>
  );
}

export default ScrollEarnings; 